module.exports = __webpack_public_path__ + "fonts/OpenSans-Medium.6b5eab14.woff2";